export default __webpack_public_path__ + "static/media/Transportation 1.b84aa91b.svg";